module.exports = __webpack_public_path__ + "static/media/N1_ROUGH.6e846328.png";